// extracted by mini-css-extract-plugin
export default {"wrapper":"DynamicTitle_wrapper__o8oWA","border":"DynamicTitle_border__9tMtr"};